export default __webpack_public_path__ + "thyssen-krupp-iconfont.ttf";